import React, { useState, useEffect } from "react";
import PageShell from "../dashboard/PageShell";
import {
  ProjectBasicInfo,
  ProjectMembers,
  ProjectAdditionalContent,
  ProjectFormActions,
} from "../../components/forms/ProjectForm";
import RichTextEditor from "../../components/forms/RichTextEditor";

const EditCompletedProject: React.FC = () => {
  const [activeTab, setActiveTab] = useState("topic-info");
  const [formData, setFormData] = useState({
    topicName: "",
    managementLevel: "",
    managementLevelInput: "",
    provinceCity: "",
    researchField: "",
    specificProgram: "",
    proposedBudget: "",
    leadUnit: "",
    leadUnitInput: "",
    governingUnit: "",
    otherGoverningUnit: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    contractingMethod: "",
    topicChair: "",
    chairName: "",
    chairGender: "",
    chairAcademicTitle: "",
    chairAcademicDegree: "",
    chairResearchTitle: "",
    chairRank: "",
    chairWorkUnit: "",
    topicSecretary: "",
    secretaryName: "",
    secretaryGender: "",
    secretaryAcademicTitle: "",
    secretaryAcademicDegree: "",
    secretaryResearchTitle: "",
    secretaryRank: "",
    secretaryWorkUnit: "",
    objective: "",
    topicType: "",
    urgencyAndNovelty: "",
    mainContents: "",
    applicationCapability: "",
    expectedBenefits: "",
    expectedResults: "",
    topicStatus: "",
    extensionCount: "",
    delayReason: "",
  });

  useEffect(() => {
    // Mock load existing data by id from URL
    setFormData((prev) => ({
      ...prev,
      topicName: "Đề tài hoàn thành – mẫu",
      managementLevel: "Cấp Viện/ Chi nhánh",
      researchField: "CNTT",
      proposedBudget: "500.000.000",
      leadUnit: "Trung tâm ABC",
      startMonth: "01",
      startYear: "2023",
      endMonth: "12",
      endYear: "2024",
      chairName: "Nguyễn Văn A",
    }));
  }, []);

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    console.log("Saving completed project:", formData);
    window.history.back();
  };

  return (
    <PageShell title="Chỉnh sửa Đề tài hoàn thành">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Chỉnh sửa đề tài
          </h1>
        </div>

        <div className="bg-white rounded-lg">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6">
              <button
                onClick={() => setActiveTab("topic-info")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "topic-info"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Thông tin đề tài
              </button>
              <button
                onClick={() => setActiveTab("full-content")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "full-content"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Nội dung đầy đủ
              </button>
            </nav>
          </div>

          <div className="p-6">
            {activeTab === "topic-info" && (
              <div className="space-y-8">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tên đề tài <span className="text-red-500">(*)</span>
                  </label>
                  <input
                    type="text"
                    value={formData.topicName}
                    onChange={(e) =>
                      handleInputChange("topicName", e.target.value)
                    }
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Nhập tên đề tài..."
                  />
                </div>

                <ProjectBasicInfo
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectMembers
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectAdditionalContent
                  formData={formData}
                  handleInputChange={handleInputChange}
                />
                {/* Trạng thái đề tài + Số lần gia hạn + Lý do chậm */}
                <div className="grid grid-cols-5 gap-4 w-full">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Số lần gia hạn
                    </label>
                    <input
                      type="number"
                      min={0}
                      value={formData.extensionCount}
                      onChange={(e) =>
                        handleInputChange("extensionCount", e.target.value)
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0"
                    />
                  </div>
                  <div className="col-span-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Lý do chậm
                    </label>
                    <input
                      type="text"
                      value={formData.delayReason}
                      onChange={(e) =>
                        handleInputChange("delayReason", e.target.value)
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Nhập lý do chậm (nếu có)"
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === "full-content" && (
              <div className="space-y-8">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Kết quả dự kiến:
                  </label>
                  <RichTextEditor
                    value={formData.expectedResults || ""}
                    onChange={(value: string) =>
                      handleInputChange("expectedResults", value)
                    }
                    placeholder="Nhập nội dung kết quả dự kiến..."
                    height="large"
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <ProjectFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default EditCompletedProject;
